import { ExecutionContext } from "../types/ExecutionContext";
import { ServiceProvider } from "../dependencies_management/ServiceProvider";
import {
	TrackedEventData,
	InternalEventData,
	GaEventData,
} from "../types/EventsData";
import { TrackingEventsSender } from "../types/TrackingEventsSender";
import { TrackingManagerStatesTransitioner } from "../types/TrackingManagerStatesTransitioner";

/**
 * This class represents a state of the TrackingManager.
 * It is based on the State pattern and contains all methods that are exposed via the TrackingManager.
 * This pattern is used to avoid multiple if/else statement checking if some variables have been initialized (ga, gtag functions, tracking codes, etc.).
 * The possible states of the TrackingManager are Uninitialized, Idle, Pending Initialization, Initialized.
 */
export abstract class TrackingManagerState implements TrackingEventsSender {
	/**
	 * The execution context to use for initialization.
	 */
	executionContext!: ExecutionContext;
	/**
	 * The tracking manager to use for switching states.
	 */
	trackingManager!: TrackingManagerStatesTransitioner & TrackingEventsSender;
	/**
	 * The service provider to access all services.
	 */
	serviceProvider!: ServiceProvider;

	/**
	 * Initializes the state.
	 */
	abstract initialize(): Promise<void>;
	abstract trackSharingEvent(webuserDataId: string): void;
	abstract trackSignedEvent(webuserDataId: string): void;
	abstract submitTrackedEvent(eventData: TrackedEventData): void;
	abstract submitInternalEvent(eventData: InternalEventData): void;
	abstract submitGAEvent(eventData: GaEventData): void;
	abstract trackContractSection(newSection: string, newGroup: string): void;
}
